<!--
*****************************************************************************
*File : View.vue
*Module : Dashboard Frontend
*Purpose : To import this file in other files to use footer .
*Author : UI Team
*Copyright : Copyright 2021, Lab to Market Innovations Private Limited
*****************************************************************************
-->

<template>
  <v-main>
    <router-view />

    <dashboard-core-footer />
  </v-main>
</template>

<script>
  export default {
    name: 'DashboardCoreView',

    components: {
      DashboardCoreFooter: () => import('./Footer')
    }
  }
</script>
